module.exports = __webpack_public_path__ + "assets/dirty-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dirty-icon.svg
// module id = 1108
// module chunks = 7